import React, { useEffect, useState } from 'react';
import { t } from '../../i18n';
import Modal from '../ui/Modal';
import { copyText, displayTvUrl, shareLink, tvUrlForRoom } from '../../utils/inviteShare';

/**
 * Host tools → Table screen. One link for a TV / iPad / laptop. Copy is the
 * required action; Share is the same iOS-safe `{ url }` as Rejoin.
 */
export function TableScreenSheet({ open, roomCode, onClose }) {
  const [copied, setCopied] = useState(false);
  const display = displayTvUrl(roomCode);
  const url = tvUrlForRoom(roomCode);

  useEffect(() => {
    if (!open) setCopied(false);
  }, [open]);

  const handleCopy = async () => {
    if (!url) return;
    try {
      await copyText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      console.warn('Copy failed:', err);
    }
  };

  const handleShare = async () => {
    if (!url) return;
    try {
      const result = await shareLink({ url });
      if (result === 'copied') {
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      }
    } catch (err) {
      console.warn('Share failed:', err);
    }
  };

  return (
    <Modal
      open={!!open && !!roomCode}
      onClose={onClose}
      title={t('tableScreen.title')}
      compact
      zClass="z-[90]"
      testId="table-screen-sheet"
    >
      <p className="text-[13.5px] text-mute m-0 mb-3">
        {t('tableScreen.body')}
      </p>
      <div
        className="w-full min-h-12 px-4 py-3 rounded-[12px] border border-line bg-transparent text-[13.5px] text-ink break-all"
        data-testid="table-screen-url"
      >
        {display}
      </div>
      <div className="mt-3 flex gap-2">
        <button
          type="button"
          onClick={handleCopy}
          style={{ WebkitTapHighlightColor: 'transparent' }}
          className="flex-1 h-12 rounded-[12px] bg-ink text-cream text-[14px] font-semibold"
          data-testid="table-screen-copy"
        >
          {copied ? t('common.copied') : t('common.copy')}
        </button>
        <button
          type="button"
          onClick={handleShare}
          style={{ WebkitTapHighlightColor: 'transparent' }}
          className="flex-1 h-12 rounded-[12px] border border-line bg-transparent text-ink text-[14px] font-medium"
          data-testid="table-screen-share"
        >
          {t('common.share')}
        </button>
      </div>
    </Modal>
  );
}
